
import React, { useEffect, useState } from 'react';
import { Table, Button, Popconfirm, Space } from 'antd';
import AppLayout from '../../components/AppLayout';

const PerformanceList: React.FC = () => {
  const [reviews, setReviews] = useState<any[]>([]);

  useEffect(() => {
    const demoData = Array.from({ length: 50 }, (_, i) => ({
      id: i + 1,
      employee_name: `Employee ${i + 1}`,
      review_period: `Q${(i % 4) + 1} 2024`,
      score: (Math.random() * 5).toFixed(1),
      status: ['Reviewed', 'Pending'][i % 2],
    }));
    setReviews(demoData);
  }, []);

  const columns = [
    { title: 'Employee Name', dataIndex: 'employee_name', key: 'employee_name' },
    { title: 'Review Period', dataIndex: 'review_period', key: 'review_period' },
    { title: 'Score', dataIndex: 'score', key: 'score' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_: any, record: any) => (
        <Space>
          <Button type="link">Edit</Button>
          <Popconfirm title="Are you sure to delete?" onConfirm={() => console.log('Delete', record.id)}>
            <Button danger type="link">Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <AppLayout>
      <Table
        dataSource={reviews}
        columns={columns}
        rowKey="id"
        pagination={{ pageSize: 10 }}
      />
    </AppLayout>
  );
};

export default PerformanceList;